var g = Object.defineProperty;
var a = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
var m = (e, c, l) => c in e ? g(e, c, { enumerable: !0, configurable: !0, writable: !0, value: l }) : e[c] = l, v = (e, c) => {
  for (var l in c || (c = {}))
    n.call(c, l) && m(e, l, c[l]);
  if (a)
    for (var l of a(c))
      o.call(c, l) && m(e, l, c[l]);
  return e;
};
var i = (e, c) => {
  var l = {};
  for (var t in e)
    n.call(e, t) && c.indexOf(t) < 0 && (l[t] = e[t]);
  if (e != null && a)
    for (var t of a(e))
      c.indexOf(t) < 0 && o.call(e, t) && (l[t] = e[t]);
  return l;
};
import * as r from "react";
const s = (t) => {
  var h = t, {
    title: e,
    titleId: c
  } = h, l = i(h, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", v({ height: 32, viewBox: "0 0 32 32", width: 32, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", "aria-labelledby": c }, l), e ? /* @__PURE__ */ r.createElement("title", { id: c }, e) : null, /* @__PURE__ */ r.createElement("path", { d: "m5.36448739 32c-2.40975074 0-4.3632397-1.953489-4.3632397-4.3632397v-20.43305155c-.00166359-.00470533-.00166359-.0098388 0-.01454413-.00124769-.02081975-.00124769-.04172001 0-.06253977.02480084-.26314051.12083876-.51454867.27779293-.72720662l4.3632397-5.81765294c.27688745-.36356557.70654566-.57839468 1.16353059-.58176529h17.45295879c.4577872 0 .8888583.21553554 1.1635306.58176529l4.3632397 5.81765294c.0272798.03404606.0520691.07001485.0741751.10762658.0059694.00805459.010859.01685581.0145441.02617944.0065111.00658446.0114787.01453265.0145442.02327061.0921135.16196443.1518822.34028255.175984.52504318.0014558.00768856.0014558.01558205 0 .02327061v.03636033c-.0013693.01208144-.0013693.0242789 0 .03636034v.02908826c.0010919.02179497.0010919.04365363 0 .0654486v20.36178532c0 2.4097507-1.953489 4.3632397-4.3632397 4.3632397zm-1.45441323-4.3632397c0 .8032502.65116299 1.4544132 1.45441323 1.4544132h20.36178531c.8032502 0 1.4544132-.651163 1.4544132-1.4544132v-18.90737206h-23.27061174zm21.81619854-21.81619853-2.1816199-2.90882647h-15.99854555l-2.18161986 2.90882647zm-17.45295883 7.27206613c0-.8032502.65116298-1.4544132 1.45441323-1.4544132.8032502 0 1.4544132.651163 1.4544132 1.4544132 0 2.4097508 1.953489 4.3632397 4.3632397 4.3632397 2.4097508 0 4.3632397-1.9534889 4.3632397-4.3632397 0-.8032502.651163-1.4544132 1.4544133-1.4544132.8032502 0 1.4544132.651163 1.4544132 1.4544132 0 4.0162513-3.2558149 7.2720662-7.2720662 7.2720662-4.0162512 0-7.27206613-3.2558149-7.27206613-7.2720662z" }));
};
export {
  s as default
};
